interface LogoProps {
  className?: string;
}

const Logo = ({ className = "h-[26px] w-auto" }: LogoProps) => (
  <img src="/logo-vexly.png" alt="Vexly AI" width={675} height={183} className={className} />
);

export default Logo;
